// Azure AD Authentication Configuration
import { ENV } from './utils/env';

// Check if environment variables are valid
if (!ENV.CLIENT_ID || ENV.CLIENT_ID === 'your_client_id') {
  console.error('ERROR: REACT_APP_CLIENT_ID is not configured correctly in .env file');
}

if (!ENV.TENANT_ID || ENV.TENANT_ID === 'your_tenant_id') {
  console.error('ERROR: REACT_APP_TENANT_ID is not configured correctly in .env file');
}

// Configure MSAL
export const msalConfig = {
  auth: {
    clientId: ENV.CLIENT_ID,
    authority: `https://login.microsoftonline.com/${ENV.TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage"
  }
};

export const loginRequest = { 
  scopes: ENV.CLIENT_ID ? [`api://${ENV.CLIENT_ID}/access_as_user`] : []
};